// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Ok-z","tupacHeader":"Pk-z","tupacHeader2":"Qk-z","tupacMenu":"Rk-z","tupacMenu2":"Sk-z","tupacMain":"Tk-z","tupacMain2":"Uk-z"};